module.exports = __webpack_public_path__ + "static/contact-intro-d-3018da2e798f32dd1601095fd908fcfd.jpg";